import {
  // Req_GetCategoryList,
  Req_GetScheduleProduct,
  Req_isAddRefPermission
} from '@/request/business'

export default {
  state: {
    vatType: '0',
    productMap: {},
    productDemandList: [],
    canAddRef: false
  },
  mutations: {
    setVatType(state,type) {
      state.vatType = type
      console.log(state.vatType)
    },
    updateProduct(state,payload) {
      const map = {}
      payload.forEach(item => {
        map[item.name] = item.categoryId 
      })
      state.productMap = map
      state.productDemandList = payload
    },
    updatePermission(state,type){
      state.canAddRef = type
    }
  },
  actions: {
    getBaseConfigList(store){
      Req_GetScheduleProduct().then(res => {
        store.commit('updateProduct',res)
      }).catch(err=>this.$catchErr(err))
    },
    getAddRefPermission(store){
      Req_isAddRefPermission().then(res => {
        store.commit('updatePermission',res)
      }).catch(err => this.$catchErr(err))
    },
  }
}


// WEBPACK FOOTER //
// ./src/store/modules/business.js